import { render, staticRenderFns } from "./HoldingsReport.vue?vue&type=template&id=4e2d41a2&scoped=true"
import script from "./HoldingsReport.vue?vue&type=script&lang=js"
export * from "./HoldingsReport.vue?vue&type=script&lang=js"
import style0 from "./HoldingsReport.vue?vue&type=style&index=0&id=4e2d41a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2d41a2",
  null
  
)

export default component.exports